<template>
    <span>
        <span :style="triggerStyle" ref="trigger">
            <slot></slot>
            <span v-if="show" class="slot-mask"></span>
        </span>
        <span class="tour" v-if="show">
            <span class="tour-overlay"></span>
            <span class="tour-content" :style="contentStyle">
                <slot name="content"></slot>
            </span>
        </span>
    </span>
</template>
<script>
export default {
    name: 'AtTour',
    
    props: {
        show: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        show: {
            handler(newVal) {
                if (newVal) {
                    this.updatePositionDelay()
                }
            },
            immediate: true
        }
    },
    mounted() {
        document.addEventListener('resize', this.updatePosition)
        document.addEventListener('scroll', this.updatePosition)
        if(this.show) this.updatePositionDelay()
    },
    destroyed() {
        document.removeEventListener('resize', this.updatePosition)
        document.removeEventListener('scroll', this.updatePosition)
    },
    data() {
        return {
            triggerStyle: {
                zIndex: 91,
                position: 'relative',
                backgroundColor: "inherit",
            },
            contentStyle: {
                position: 'absolute',
                zIndex: 92,
            }
        }
    },
    methods: {
        updatePositionDelay() {
            setTimeout(() => {
                this.updatePosition()
            }, 100)
        },
        updatePosition() {
            
            if (!this.$refs.trigger) return;
            
            const rect = this.$refs.trigger.getBoundingClientRect()
            
            this.$set(this.contentStyle, 'left', `${rect.left}px`)
            this.$set(this.contentStyle, 'top', `${rect.top + rect.height}px`)
        }
    }
}
</script>
<style lang="less" scoped>
.tour {
    position: fixed;
    width: 100vw;
    height: 100vh;
    left: 0;
    top: 0;
    z-index: 90;
    
    .tour-overlay {
        position: absolute;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.59);
        pointer-events: auto; /* 遮罩层接收点击事件，防止点击到下方内容 */
        transition: all .3s;
    }
}

.slot-mask {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
}
</style>
